import DOMPurify from 'dompurify'

/**
 * Extract a plain-text representation of a message body suitable for copying or
 * forwarding. Rich agent replies arrive as HTML (message_type === 'html'); we
 * sanitize then strip tags via the DOM so entities/lists/breaks collapse to
 * readable text. Plain messages are returned unchanged.
 */
export function toPlainText(content: string, messageType?: string): string {
  if (!content) return ''
  if (messageType !== 'html') return content

  try {
    const clean = DOMPurify.sanitize(content, { ALLOWED_ATTR: [] })
    const doc = new DOMParser().parseFromString(
      // Turn block boundaries into newlines so the text doesn't run together.
      clean
        .replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, '\n')
        .replace(/<br\s*\/?>(?!$)/gi, '\n'),
      'text/html'
    )
    const text = doc.body.textContent || ''
    return text.replace(/\n{3,}/g, '\n\n').trim()
  } catch {
    // Last-resort: crude tag strip.
    return content.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  }
}
